import { getPagePath, trans } from '@spotahome/soyuz/client';

import HeartLockIcon from '@spotahome/ui-library/src/tenant/components/icons/HeartLockIcon';

import LandingSocialBannerSection from '@spotahome/landings-common/src/components/LandingSocialBannerSection';

const Social = () => {
  return (
    <LandingSocialBannerSection
      title={trans('tenant_guarantees.social.title')}
      cta={{
        url: getPagePath('landing'),
        text: trans('tenant_guarantees.social.cta')
      }}
      renderIcon={() => <HeartLockIcon size={80} />}
    />
  );
};

export default Social;
